import firebase from '../Firebase/Firebase';

const call = (name) => firebase.app().functions('europe-west1').httpsCallable(name);

export const listAvailableDemands = async () => {
  const result = await call('listAvailableDemands')({});
  return result.data?.demands || [];
};

export const getPublicDiscoveryFeed = async () => {
  const result = await call('getPublicDiscoveryFeed')({});
  return {
    artisans: result.data?.artisans || [],
    demands: result.data?.demands || [],
    projects: result.data?.projects || [],
    stats: result.data?.stats || null,
  };
};

export const setDemandPublicPreview = async ({ demandId, enabled }) => {
  const result = await call('setDemandPublicPreview')({ demandId, enabled });
  return result.data;
};

export const listPublicReviewedProjects = async () => {
  const result = await call('listPublicReviewedProjects')({});
  return result.data?.projects || [];
};

export const submitDemandOffer = async ({ demandId, offer }) => {
  const result = await call('submitDemandOffer')({ demandId, offer });
  return result.data;
};

export const decideDemandOffer = async ({ demandId, artisanId, decision }) => {
  const result = await call('decideDemandOffer')({ demandId, artisanId, decision });
  return result.data;
};

export const answerDemandOfferClarification = async ({ demandId, artisanId, response }) => {
  const result = await call('answerDemandOfferClarification')({ demandId, artisanId, response });
  return result.data;
};

export const withdrawDemandOfferSecurely = async ({ demandId }) => {
  const result = await call('withdrawDemandOffer')({ demandId });
  return result.data;
};

export const performDemandAction = async ({ demandId, action, payload = {} }) => {
  const result = await call('performDemandAction')({ demandId, action, payload });
  return result.data;
};

export const deleteDemandSecurely = async ({ demandId }) => {
  const result = await call('deleteDemandSecurely')({ demandId });
  return result.data;
};
